module.exports = "/assets/images/skull.png";